import { addYears, addMonths, addWeeks, addDays, subYears, subMonths, subWeeks, subDays, isAfter, isSameMonth, isSameWeek, isSameDay, isBefore } from 'date-fns';

var nextDate = function nextDate(mode, selected) {
  switch (mode) {
    case 'date':
      {
        return addDays(selected, 1);
      }
    case 'week':
      {
        return addWeeks(selected, 1);
      }
    case 'month':
      {
        return addMonths(selected, 1);
      }
    case 'year':
      {
        return addYears(selected, 1);
      }
  }
};
var prevDate = function prevDate(mode, selected) {
  switch (mode) {
    case 'date':
      {
        return subDays(selected, 1);
      }
    case 'week':
      {
        return subWeeks(selected, 1);
      }
    case 'month':
      {
        return subMonths(selected, 1);
      }
    case 'year':
      {
        return subYears(selected, 1);
      }
  }
};
var isNextDisabled = function isNextDisabled(maxDate, mode, selected) {
  if (!maxDate) {
    return false;
  }
  var next = nextDate(mode, selected);
  switch (mode) {
    case 'date':
      {
        return isAfter(next, maxDate) && !isSameDay(next, maxDate);
      }
    case 'week':
      {
        return isAfter(next, maxDate) && !isSameWeek(next, maxDate, {
          weekStartsOn: 1
        });
      }
    case 'month':
      {
        return isAfter(next, maxDate) && !isSameMonth(next, maxDate);
      }
    case 'year':
      {
        return next.getFullYear() > maxDate.getFullYear();
      }
  }
};
var isPrevDisabled = function isPrevDisabled(minDate, mode, selected) {
  if (!minDate) {
    return false;
  }
  var prev = prevDate(mode, selected);
  switch (mode) {
    case 'date':
      {
        return isBefore(prev, minDate) && !isSameDay(prev, minDate);
      }
    case 'week':
      {
        return isBefore(prev, minDate) && !isSameWeek(prev, minDate, {
          weekStartsOn: 1
        });
      }
    case 'month':
      {
        return isBefore(prev, minDate) && !isSameMonth(prev, minDate);
      }
    case 'year':
      {
        return prev.getFullYear() < minDate.getFullYear();
      }
  }
};
var getYearItems = function getYearItems(minDate, maxDate) {
  var rangeMax = maxDate || new Date();
  var rangeMin = minDate || new Date();
  if (!minDate) {
    rangeMin.setFullYear(rangeMax.getFullYear() - 12);
  }
  if (rangeMax <= rangeMin) {
    throw new RangeError('The max date must be greater than the minimum date');
  }
  var itemCount = rangeMax.getFullYear() - rangeMin.getFullYear();
  var years = [];
  for (var i = 0; i <= itemCount; i++) {
    var year = addYears(rangeMin, i).getFullYear();
    years.push(year);
  }
  return years;
};

export { getYearItems, isNextDisabled, isPrevDisabled, nextDate, prevDate };
